import { vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toggle--container", `orientation--${_ctx.orientation}`])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["toggle--inner", `orientation--${_ctx.orientation}`])
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        id: `switch-${_ctx.uid}-${_ctx.label}`,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.switchValue) = $event)),
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["stop"]))
      }, null, 8, _hoisted_1), [
        [_vModelCheckbox, _ctx.switchValue]
      ]),
      _createElementVNode("label", {
        for: `switch-${_ctx.uid}-${_ctx.label}`
      }, null, 8, _hoisted_2)
    ], 2),
    _withDirectives(_createElementVNode("span", { class: "toggle--label" }, _toDisplayString(_ctx.label), 513), [
      [_vShow, _ctx.label]
    ])
  ], 2))
}